import fetch from 'cross-fetch';

import { transformCategory, transformSubCategory, transformTest } from '../helpers/transformers';
import { CategoriesData, SubCategoriesData, TestData } from '../types';


export const getCategories = async (): Promise<CategoriesData[]> => {
  const response = await fetch('https://storage.googleapis.com/genica-webflow-data/categories.json', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
  });

  const data = await response.json();

  if (data.length === 0) {
    return [];
  }

  return data.map(transformCategory);
};

export const getSubCategories = async (): Promise<SubCategoriesData[]> => {
  const response = await fetch('https://storage.googleapis.com/genica-webflow-data/sub_categories.json', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  if (data.length === 0) {
    return [];
  }

  return data.map(transformSubCategory);
};

export const getTests = async (): Promise<TestData[]> => {
  const response = await fetch('https://storage.googleapis.com/genica-webflow-data/tests.json', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  if (data.length === 0) {
    return [];
  }

  return data.map(transformTest);
};
